export const NotFoundPage = () => {
    return (
        <>
            <h1>Error 404</h1>
            <h2>Página no encontrada U.U</h2>
        </>
    )
}